import { joinClassNames } from "utils/joinClassNames";

export const Input = ({
  type = "text",
  autoComplete = "off",
  name,
  placeholder = "",
  onChange,
  onBlur,
  value,
  placeholderSuffix = "",
  maxLength,
  isInvalid = false,
}) => {
  const placeholderString = placeholderSuffix
    ? `${placeholder} ${placeholderSuffix}`
    : placeholder;

  return (
    <input
      name={name}
      className={joinClassNames(isInvalid && "border-red")}
      placeholder={placeholderString}
      type={type}
      autoComplete={autoComplete}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      maxLength={maxLength}
    />
  );
};
